const NoResultsFound = ({ message }) => <td colSpan={8} style={{ textAlign: 'center' }}>{message || "No Results Found"}</td>;

export default NoResultsFound;
